import {OfferModal} from "../../../offer/components/offer_modal/OfferModal";
import {useVendorOffers} from "../../../offer/hooks/use_vendor_offers";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {useAppSelector} from "../../../store/hooks";
import {FilterPresets, useUserPreferencesFilters} from "../../../user/hooks/use_user_preferences_filters";

interface IProps {
    vendorId: number;
}

const modalName: IOfferModalName = "mainOfferModal";

export function VendorDetailOfferModal(props: IProps) {
    const {vendorId} = props;

    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const userPreferencesFilters = useUserPreferencesFilters(FilterPresets.WithoutRegion);
    const vendorOffersQuery = useVendorOffers(!isOpen, vendorId);

    return <OfferModal modalName={modalName} offersQuery={vendorOffersQuery} userPreferencePropertyFilters={userPreferencesFilters} />;
}
import {OfferModal} from "../../../offer/components/offer_modal/OfferModal";
import {useVendorOffers} from "../../../offer/hooks/use_vendor_offers";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {useAppSelector} from "../../../store/hooks";
import {FilterPresets, useUserPreferencesFilters} from "../../../user/hooks/use_user_preferences_filters";

interface IProps {
    vendorId: number;
}

const modalName: IOfferModalName = "mainOfferModal";

export function VendorDetailOfferModal(props: IProps) {
    const {vendorId} = props;

    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const userPreferencesFilters = useUserPreferencesFilters(FilterPresets.WithoutRegion);
    const vendorOffersQuery = useVendorOffers(!isOpen, vendorId);

    return <OfferModal modalName={modalName} offersQuery={vendorOffersQuery} userPreferencePropertyFilters={userPreferencesFilters} />;
}
